export default "__VITE_ASSET__6da7603d__"